import React, {useEffect, useState, useRef} from 'react'
import SVG from 'react-inlinesvg'
import arrow from '../../../_metronic/images/arr072.svg'
import _ from 'lodash'

export default function DropdownFilter({title, options, setOptions, applyFilter}: any) {
  const [searchOptions, setSearchOption] = useState<any>('')

  const inputRef = useRef<any>()

  useEffect(() => {
    // initialize debounce function to search once user has stopped typing every half second
    inputRef.current = _.debounce(search, 500)
  }, [])
  // Search the dropdown value
  const search = (event: any) => {
    setSearchOption(event.target.value)
  }

  // Clear all the selected Checkbox
  const clearAllCheckbox = async () => {
    setSearchOption('')
    applyFilter([])
    setOptions((prev: any) => prev.map((option: any) => ({...option, checked: false})))
  }

  // Function to select and unselect the checkboxes
  const onSelect = async (e: any, data: any) => {
    setOptions((prev: any) => {
      return options.map((item: any) => {
        if (item.id === data.id) {
          return {...item, checked: e.target.checked}
        }
        return item
      })
    })
  }

  // Applying Filters to query the data
  const handleApplyFilters = () => {
    applyFilter(options?.filter((option: any) => option.checked).map((data: any) => data.id))
  }
  const renderDropdownTitle = () => {
    let selectedLength = options?.filter((data: any) => data.checked).length
    if (selectedLength) {
      return `${selectedLength} selected`
    } else {
      return `All ${title}`
    }
  }
  console.log(options)
  return (
    <>
      <div className='h-38px border-0 rounded'>
        <button
          className='btn btn-sm d-flex align-items-center justify-content-between w-170px'
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-end'
          style={{
            borderRadius: '6px',
            background: '#ffff',
            height: '43px',
            width: '218px',
            paddingLeft: '30px',
            color: '#7E8299',
          }}
        >
          {renderDropdownTitle()}
          <span className={`svg-icon svg-icon-2`}>
            <SVG src={arrow} width='22px' height='22px' />
          </span>
        </button>

        {/* begin::Menu */}
        <div
          className=' menu menu-sub menu-sub-dropdown'
          style={{width: '220px'}}
          data-kt-menu='true'
        >
          <div className='mx-1 my-1 menu-item' data-kt-sticky-top='auto'>
            <input
              type='text'
              style={{width: '210px'}}
              className='form-control form-control-solid'
              placeholder='Search'
              value={searchOptions}
              onChange={(e) => {
                search(e)
              }}
            />
          </div>
          <div
            className='menu-column menu-gray-600 overlay-y menu-state-bg-primary fs-7 py-4 w-160px'
            // data-kt-menu='true'
            style={{
              borderRadius: '6px',
              width: '215px',
              maxHeight: '304px',
              overflowY: 'scroll',
            }}
          >
            {options
              .filter((item: any) =>
                `${item.firstName} 
             ${item.lastName}`
                  .toLowerCase()
                  .includes(searchOptions?.toLowerCase())
              )
              .map((optionData: any, index: any) => {
                return (
                  <div
                    className='menu-item w-160px'
                    style={{width: '200px ', padding: '12px 16px'}}
                    key={index}
                  >
                    <div className='form-check form-check-sm form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={optionData?.checked}
                        value={optionData.firstName}
                        onClick={(e) => {
                          onSelect(e, optionData)
                        }}
                      />
                      <label
                        htmlFor=''
                        style={{color: '#5E6278'}}
                        className='form-check-label fw-semibold fs-5'
                      >
                        {optionData.firstName} {optionData.lastName}
                      </label>
                    </div>
                  </div>
                )
              })}
          </div>
          <div className='menu-item my-1'>
            <button
              style={{
                width: '85px',
                height: '36px',
                marginBottom: '10px',
                marginRight: '10px',
                fontSize: '13px',
              }}
              className='btn btn-secondary w-59px h-36px mx-4 p-0'
              onClick={clearAllCheckbox}
            >
              Clear
            </button>
            <button
              style={{
                width: '85px',
                height: '36px',
                marginBottom: '10px',
                marginRight: '10px',
                fontSize: '13px',
              }}
              className='btn btn-primary w-59px h-36px mx-2 me-3 p-0'
              onClick={() => handleApplyFilters()}
              data-kt-menu-dismiss='true'
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
